import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClassMasterCreateRequestDTO, ClassMasterDTO, ClassMasterUpdateRequestDTO, ClassMasterList, ClassMasterDeleteRequestDTO, ClassMasterReadByIdRequestDTO, ClassMasterReadBySchoolIdRequestDTO, ClassMasterCreateBulkRequestDTO, ClassMasterMarkAttendanceRequestDTO, ClassMasterCheckAttendanceReuestDTO, StudentListResponse, ClassMasterMarkStudentAttendanceRequestDTO, ClassMasterGetPendingFeeBySchoolIdRequestDTO, ClassMasterGetPendingFeeList, ClassMasterGetPendingFeeBySchoolIdDTO } from './class-master.interface';
import { ClassMaster_Create, ClassMaster_Update, ClassMaster_ReadAll, ClassMaster_Delete, ClassMaster_ReadById, ClassMaster_ReadBySchoolId, ClassMaster_ReadBySchoolId_External, ClassMaster_ReadAllPaginated, ClassMaster_CreateBulk, ClassMaster_MarkAttendance, ClassMaster_CheckAttendance, ClassMaster_MarkStudentAttendance, ClassMaster_GetPendingFeeBySchoolId } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class ClassMasterService {

  constructor() { }

  http = inject(HttpClient)


  ClassMaster_Create(data: ClassMasterCreateRequestDTO): Observable<ClassMasterDTO> {
    return this.http.post<ClassMasterDTO>(ClassMaster_Create, data)
  }

  ClassMaster_Update(data: ClassMasterUpdateRequestDTO): Observable<ClassMasterDTO> {
    return this.http.post<ClassMasterDTO>(ClassMaster_Update, data)
  }

  ClassMaster_ReadAll(): Observable<ClassMasterList> {
    return this.http.get<ClassMasterList>(ClassMaster_ReadAll)
  }
  ClassMaster_Delete(data: ClassMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ClassMaster_Delete, data)
  }


  ClassMaster_ReadById(data: ClassMasterReadByIdRequestDTO): Observable<ClassMasterDTO> {
    return this.http.post<ClassMasterDTO>(ClassMaster_ReadById, data)
  }

  ClassMaster_ReadBySchoolId(data: ClassMasterReadBySchoolIdRequestDTO): Observable<ClassMasterList> {
    return this.http.post<ClassMasterList>(ClassMaster_ReadBySchoolId, data)
  }

  ClassMaster_ReadBySchoolId_External(
    data: ClassMasterReadBySchoolIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<ClassMasterList> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set('X-Api-Key', xApiKey)
        .set('X-Api-Timestamp', xApiTimestamp || '')
        .set('X-Api-Nonce', xApiNonce || '')
        .set('X-Api-Signature', xApiSignature);
    }
    return this.http.post<ClassMasterList>(ClassMaster_ReadBySchoolId_External, data, { headers });
  }

  ClassMaster_ReadAllPaginated(data: ClassMasterReadBySchoolIdRequestDTO): Observable<ClassMasterList> {
    return this.http.post<ClassMasterList>(ClassMaster_ReadAllPaginated, data)
  }

  ClassMaster_CreateBulk(data: ClassMasterCreateBulkRequestDTO): Observable<ClassMasterList> {
    return this.http.post<ClassMasterList>(ClassMaster_CreateBulk, data);
  };

  ClassMaster_MarkAttendance(data: ClassMasterMarkAttendanceRequestDTO): Observable<void> {
    return this.http.post<void>(ClassMaster_MarkAttendance, data)
  }

  ClassMaster_CheckAttendance(data: ClassMasterCheckAttendanceReuestDTO): Observable<StudentListResponse>{
    return this.http.post<StudentListResponse>(ClassMaster_CheckAttendance,data)
  }
  ClassMaster_MarkStudentAttendance(data: ClassMasterMarkStudentAttendanceRequestDTO): Observable<void>{
  return this.http.post<void>(ClassMaster_MarkStudentAttendance,data)
  }

  ClassMaster_GetPendingFeeBySchoolId(data: ClassMasterGetPendingFeeBySchoolIdRequestDTO): Observable<ClassMasterGetPendingFeeBySchoolIdDTO[]> {
  return this.http.post<ClassMasterGetPendingFeeBySchoolIdDTO[]>(
    ClassMaster_GetPendingFeeBySchoolId,
    data
  );
}
}
